import { render, staticRenderFns } from "./SelectBuyGoods.vue?vue&type=template&id=1948acf9&scoped=true&"
import script from "./SelectBuyGoods.vue?vue&type=script&lang=js&"
export * from "./SelectBuyGoods.vue?vue&type=script&lang=js&"
import style0 from "./SelectBuyGoods.vue?vue&type=style&index=0&id=1948acf9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1948acf9",
  null
  
)

export default component.exports